module.exports = __webpack_public_path__ + "img/coupon-use.017aac93.png";